export default __webpack_public_path__ + "static/media/peerlearning.ba93633e.svg";